import { z } from 'zod';

import { makeListQuery } from '../../common/list-query/list-query';

import { SettingScopeTypeSchema } from '../setting-scope/setting-scope';

/**
 * The whitelisted filters of the stored-values list (N7).
 *
 * The settings **screen** is driven by the registry-metadata endpoint, not by
 * this list — this one answers "what has actually been overridden?", which is
 * the audit-shaped view an operator needs before changing policy.
 */
export const SettingsListQuerySchema = makeListQuery({
  group: z.string().min(1).max(64).optional(),
  subgroup: z.string().min(1).max(64).optional(),
  search: z.string().min(1).max(200).optional(),
  scopeType: SettingScopeTypeSchema.optional(),
});

export type SettingsListQuery = z.infer<typeof SettingsListQuerySchema>;
